import { Classificacao } from "./Classificacao";
import { Assunto } from "./Assunto";
import { SubAssunto } from "./SubAssunto";
import { Legislacao } from "./Legislacao";

export class Irregularidade {
    idIrregularidade: any;
    nomeIrregularidade: any;
    dsIrregularidade: any;
    codIrregularidade: any;
    flAtivo: boolean;
    classificacao: Classificacao;
    assunto: Assunto;
    subAssunto: SubAssunto;
    legislacao: Legislacao;
    modulo: any;

    constructor() {
        this.idIrregularidade = "0";
        this.nomeIrregularidade = "";
        this.dsIrregularidade = "";
        this.codIrregularidade = "";
        this.flAtivo = true;
        this.classificacao = new Classificacao();
        this.assunto = new Assunto();
        this.subAssunto = new SubAssunto();
        this.legislacao = new Legislacao();
        this.modulo = [];
    }

    public setIrregularidade(irregularidadeInfo) {
        this.idIrregularidade = irregularidadeInfo.idIrregularidade;
        this.nomeIrregularidade = irregularidadeInfo.nomeIrregularidade;
        this.dsIrregularidade = irregularidadeInfo.descIrregularidade;
        this.codIrregularidade = irregularidadeInfo.codIrregularidade;
        this.flAtivo = irregularidadeInfo.flAtivo;
        this.classificacao = irregularidadeInfo.classificacao;
        this.assunto = irregularidadeInfo.assunto;
        this.subAssunto = irregularidadeInfo.subAssunto;
        this.legislacao = irregularidadeInfo.legislacao;

        // irregularidadeInfo.modulo.forEach(mod => {
        //     this.modulo.push(mod);
        // });

        this.modulo = irregularidadeInfo.modulo;
    }

}



// WEBPACK FOOTER //
// ./src/models/Irregularidade.ts